import { HStack } from '@genial/components';
import React from 'react';

import { useGlobalProductContext } from '../../contexts';
import { ProductCategories } from '../ProductCategories';
import { ProductFilters, ProductFiltersDisabled } from '../ProductFilters';
import { ProductOrderBy } from '../ProductOrderBy';
import { ProductsRefreshList } from '../ProductsRefreshList';

export interface ProductHandlersProps {
  customButton?: React.ReactNode;
}

export const ProductHandlers: React.FC<ProductHandlersProps> = ({ customButton }) => {
  const hasCategories = true;
  const { product, isDesktop } = useGlobalProductContext();

  const isEquity = product.id === 'equity';

  if (!hasCategories || !isDesktop) {
    return (
      <HStack w="full" justifyContent="space-between" alignItems="center" pt="stack.xxs">
        <HStack alignItems="center">
          <ProductsRefreshList />
          <ProductOrderBy />
        </HStack>
        <HStack space="inline.nano" alignItems="center">
          {isEquity ? <ProductFiltersDisabled /> : <ProductFilters />}
          {customButton}
        </HStack>
      </HStack>
    );
  }

  return (
    <HStack w="full" justifyContent="space-between" alignItems="center" pt="stack.xxs">
      <ProductCategories />
      <HStack space="inline.nano" alignItems="center">
        <ProductsRefreshList />
        <ProductOrderBy />
        <ProductFilters />
        {customButton}
      </HStack>
    </HStack>
  );
};
